import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { api } from "../../config";
import { Modal } from "antd";

import MainButton from "../components/common/mainButton";
import { useTranslation } from "react-i18next";

import store from "../redux/store";
import * as Actions from "../redux/actions";

import Loading from "../components/common/loading";

const GetCatalogo = ({ catalogos, pdfLink, userId, setCatalogs, language,  }) => {
  const { t } = useTranslation(["data"]);

  let { pathname } = useLocation();

  return catalogos.map((element, i) => {
    return (
      <div key={i} className="block">
        <div className="block-title">{element.name}</div>
        <div className={element.owner === userId ? "background custom" : "background"}>
          <img src={element.owner === userId ? "/assets/img/customCat-icon.png" : `${api.media.images}${element.code}`} />
        </div>
        <div className="button-catalogo">
          <MainButton
            link={`${pathname}/${element.code}`}
            name={t("verProductos")}
          />
        </div>
        <div className={`${element.owner === userId ? "pdfsButtons btnSpacebtw" : "pdfsButtons btnCenter"}`}>
          <div className="box">
            {element.haspdf !== 0 && (
              <a
                target="_blank"
                href={element.owner === userId ? `/api/es/catalogpdf/${element.code}` : `${pdfLink}${element.code}`}
              >
                <div className="icon-descargar">
                  <img src="/assets/img/descargar-pdf.png" />
                </div>
                <span>Descargar PDF</span>
              </a>
            )}
          </div>
          {element.owner === userId && (

          <div className="box">
              <a
                onClick={(e) => {
                  e.preventDefault();

                  Modal.confirm({
                    title: "Confirmar",
                    content: "Estas seguro/a que quieres eliminar catálogo ?",
                    okText: "Eliminar",
                    cancelText: "Cancelar",
                    onOk:() => {

                      store.dispatch(Actions.deleteCatalogo(element.code)).then(() =>{
                        store.dispatch(Actions.getCatalogos()).then((data) => {
                          setCatalogs(data.payload.data.catalogs);
                        });
                      })


                    }
                  });
                }}
              >
                <div className="icon-descargar">
                  <img src="/assets/img/delete-icon.png" />
                </div>
              </a>
          </div>
          )}
        </div>
      </div>
    );
  });
};

const Catalogo = () => {
  const { t } = useTranslation(["data"]);

  const [catalogs, setCatalogs] = useState();

  const { userId } = useSelector((state) => state.login.userLoged);

  useEffect(() => {
    store.dispatch(Actions.getCatalogos()).then((data) => {

      setCatalogs(data.payload.data.catalogs);
    });
  }, []);

  const language = window.ferrero.locale;

  return (
    <div className="marcas-container">
      <div className="marcasTitle">{t("porCatalogos")}</div>

      <div className="content">
        {catalogs && (
          <GetCatalogo
            catalogos={catalogs}
            pdfLink={api.media.pdf}
            userId={userId}
            setCatalogs={setCatalogs}
            language={language}
          />

        )}

        {!catalogs && <Loading />}
      </div>

    </div>
  );
};

export default Catalogo;
